var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PostError',[_c('Dialog',{attrs:{"type":'success',"content-title":'验证成功',"content-text":'邮箱验证成功，请等待审核，审核成功后，会有短信通知'},model:{value:(_vm.dialogStatus),callback:function ($$v) {_vm.dialogStatus=$$v},expression:"dialogStatus"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }